<template>
  <div id="channels-modal">
    <vue-link :to="currentPath" class="closer"></vue-link>

    <div class="modal">
      <vue-link :to="currentPath" class="close-btn">✕</vue-link>
      <ul>
        <li class="section">MONKEYPAW</li>
        <li>
          <ul>
            <a href="https://twitter.com/Monkeypaw" target="_blank" rel="noreferrer">
              <font-awesome-icon :icon="['fab', 'twitter']" />
            </a>
            <a href="https://www.instagram.com/monkeypawproductions/" target="_blank" rel="noreferrer">
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </a>
            <a href="https://www.facebook.com/monkeypawproductions" target="_blank" rel="noreferrer">
              <font-awesome-icon :icon="['fab', 'facebook']" />
            </a>
            <a href="https://www.tiktok.com/@monkeypawproductions?lang=en" target="_blank" rel="noreferrer">
              <font-awesome-icon :icon="['fab', 'tiktok']" />
            </a>
            <a href="https://www.reddit.com/r/MonkeypawProductions/" target="_blank" rel="noreferrer">
              <font-awesome-icon :icon="['fab', 'reddit']" />
            </a>
            <a href="https://t.snapchat.com/IJgnPxuJ" target="_blank" rel="noreferrer">
              <font-awesome-icon :icon="['fab', 'snapchat']" />
            </a>
          </ul>
        </li>
      </ul>
      <p>
        These are our official social channels. Please be wary of other channels posing as Monkeypaw or Jordan Peele.
        Sites trying to sell you access to Monkeypaw events, or soliciting scripts in exchange for fees are fraudulent.
      </p>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInstagram, faTwitter, faFacebook, faTiktok, faReddit, faSnapchat } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faInstagram)
library.add(faTwitter)
library.add(faFacebook)
library.add(faTiktok)
library.add(faReddit)
library.add(faSnapchat)

export default {
  name: 'ChannelsModal',
  components: { FontAwesomeIcon },
  computed: {
    currentPath() {
      return this.$route.path
    },
  },
}
</script>

<style scoped>
#channels-modal {
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.closer {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

.modal {
  width: 40%;
  height: auto;
  max-height: 90vh;
  border: 1px dashed white;
  border-radius: var(--br);
  padding: 6rem 1rem 3rem 1rem;
  background-color: black;
  z-index: 10;
  position: relative;
}

.modal ul {
  font: var(--nord);
  text-transform: uppercase;
}

.modal p {
  text-align: center;
  font-size: 1.5rem;
  margin-top: 3rem;
  color: white;
}

.modal ul li {
  margin: 0;
  padding: 0;
  text-align: center;
  white-space: nowrap;
  color: white;
}

.modal ul li.section {
  margin-bottom: 1rem;
}

.modal ul li.section:after {
  content: '';
  width: 70px;
  display: block;
  height: 1px;
  border-bottom: 1px dashed white;
  margin: 0 auto;
  padding-top: 1rem;
}

.modal ul ul.no-padding {
  margin-bottom: 0rem;
}

.modal ul ul {
  margin-bottom: 3rem;
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal ul ul a {
  margin: 0px 1.5rem;
}

.modal ul ul a svg {
  width: auto;
  height: 3rem;
}

.close-btn {
  position: absolute;
  top: 0.5rem;
  right: 1rem;
  font: var(--nord);
  text-transform: uppercase;
  background: none;
  outline: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 2rem;
}

@media (max-width: 500px) {
  .modal {
    width: 90%;
  }

  .modal ul ul a {
    margin: 0px 1rem;
  }
  .modal ul ul a svg {
    width: auto;
    height: 4rem;
  }
}
</style>
